/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Page transition animation
 * @export
 */
export const DatabasePageTransitionName = {
    Flow: 'FLOW',
    Flip: 'FLIP',
    Fade: 'FADE'
} as const;
export type DatabasePageTransitionName = typeof DatabasePageTransitionName[keyof typeof DatabasePageTransitionName];


export function DatabasePageTransitionNameFromJSON(json: any): DatabasePageTransitionName {
    return DatabasePageTransitionNameFromJSONTyped(json, false);
}

export function DatabasePageTransitionNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePageTransitionName {
    return json as DatabasePageTransitionName;
}

export function DatabasePageTransitionNameToJSON(value?: DatabasePageTransitionName | null): any {
    return value as any;
}

